export default __webpack_public_path__ + "997c76d442401513c25c795386dda9bd.png";